import * as React from 'react';
import { useAutocomplete } from '@mui/core/AutocompleteUnstyled';
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import Splittext from '../../CustomFunction/Splittext/Splittext';
import { Divider, FormLabel, IconButton, InputBase, Paper } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

const Label = styled('label')({

    position: 'static',
    whiteSpace: "nowrap",
    // verticalAlign: "middle",
    backgroundColor: "#eee",
    borderRadius: "4px  0 0  4px ",
    border: "1px solid #ccc",
    lineHeight: "33px",
    marginTop: 5,
    height: "33px",
    minWidth: "100px",
    textAlign: "center",
    fontWeight: "100"
});

const Input = styled('input')(({ theme }) => ({
    lineHeight: "33px",
    width: "400",
    marginTop: 4,
    height: "33px",
    border: "1px solid #ccc",
    whiteSpace: "nowrap",
}));
// absolute
const Listbox = styled('ul')(({ theme }) => ({

    minWidth: 250,
    marginTop: -1,
    marginRight: 5,
    padding: 1,
    zIndex: 1999,
    position: "absolute",
    // listStyle: 'none',
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
    maxHeight: 200,
    cursor: 'pointer',
    border: '1px solid rgba(0,0,0,.25)',
    '& li[data-focus="true"]': {
        backgroundColor: '#4a8df6',
        color: 'white',

    },
    '& li:active': {
        backgroundColor: '#2977f5',
        color: 'white',
    },
}));

export default function UseAutocomplete(props) {
    const { title, placeholder, id, datalist } = props
    // const loading = open && options.length === 0;

    const {
        getRootProps,
        getInputLabelProps,
        getInputProps,
        getListboxProps,
        getOptionProps,
        groupedOptions,
    } = useAutocomplete({
        id: { id },
        options: datalist,
        autoSelect: false,
        getOptionLabel: (option) => option.CODE + ":" + option.MYNAMETH,
        onInputChange: e => checkATCaction(e),
        fullWidth: true
    });

    const checkATCaction = (e) => {

        try {
            if (e.target.firstChild.data !== "") {
                let forprops = Splittext(e.target.firstChild.data, ":")
                // console.log("forprops", forprops[0].trim());
                props.valueReturn(forprops[0].trim())
            }
        } catch (er) {
            console.log("err", er);

            props.valueReturn("nodata")

            // props.valueReturn("notdata")
        }
    }

    const onclick = (e) => {
        try {
            props.activate(e)
        } catch (error) {
            console.log("not activate prams");
        }

    }
    return (
        <>
            <Paper
                component="form"
                sx={{ display: 'flex', alignItems: 'center', width: "100%", boxShadow: "none" }}
            >
                <FormLabel id="demo-radio-buttons-group-label" sx={{
                    paddingTop: "5px",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                    paddingBottom: "5px",
                    color: "#555",
                    fontSize: '14px',
                    fontWeight: "700",
                    border: 1,
                    borderTopLeftRadius: 4,
                    borderBottomLeftRadius: 4,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    lineHeight: 1.5,
                    fontFamily: "Customfont !important",
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    minWidth: "100px",
                    textAlign: "center"
                }}> {title}</FormLabel>

                {/* <IconButton sx={{ p: '1px 5px', color: "GrayText", fontSize: '14px', fontWeight: 700, border: 1, borderColor: "red" }} aria-label="menu">
                    {title}
                </IconButton> */}
                <Input {...getInputProps()} onClick={e => onclick(true)} placeholder={placeholder} sx={{ marginTop: "-5px !important", width: "100%" }} />
            </Paper>
            {groupedOptions.length > 0 ? (
                <Listbox {...getListboxProps()}>
                    {groupedOptions.map((option, index) => (
                        <li {...getOptionProps({ option, index })}>{option.CODE + " : " + option.MYNAMETH}</li>
                    ))}
                </Listbox>
            ) : null}
        </>


        // <div>
        //     <div {...getRootProps()}>
        //         <Label {...getInputLabelProps()} style={{ fontWeight: 700 }}> {title} </Label>
        //         <Input {...getInputProps()} onClick={e => onclick(true)} placeholder={placeholder}
        //         />
        //     </div>
        // {groupedOptions.length > 0 ? (
        //     <Listbox {...getListboxProps()}>
        //         {groupedOptions.map((option, index) => (
        //             <li {...getOptionProps({ option, index })}>{option.CODE + " : " + option.MYNAMETH}</li>
        //         ))}
        //     </Listbox>
        // ) : null}
        // </div>

    );
}


UseAutocomplete.propTypes = {
    title: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    datalist: PropTypes.array
}


